<script>
import axios from '../../../../utils/api';

export default {
  name: "GoogleCallback",
  data() {
    return {
      isLoading: true,
      error: null
    };
  },
  methods: {
    handleGoogleCallback() {
      // Get code from URL query params
      const urlParams = new URLSearchParams(window.location.search);
      const googleCode = urlParams.get('code');

      if (!googleCode) {
        this.error = this.$t('login.errors.noCode');
        this.isLoading = false;
        setTimeout(() => {
          this.$router.push({ path: '/auth/login' });
        }, 3000);
        return;
      }

      axios.post('/invoices/auth/login', {
        google_code: googleCode
      })
        .then((response) => {
          const data = response.data;

          if (data.status) {
            // Save response to storage
            localStorage.setItem('token', data.data.token);
            localStorage.setItem('secret', data.data.secret);

            this.$store.dispatch('doLogin');
            this.$toast.success(data.message);

            // Redirect to dashboard
            const isApiDocs = JSON.parse(localStorage.getItem('is-api-docs')) || false;
            if (isApiDocs) {
              this.$router.push({ path: '/dashboard/api-management' });
            } else {
              this.$router.push({ path: '/dashboard' });
            }
          } else {
            const errorMessage = data.errors ? Object.values(data?.data?.errors)[0] : this.$t('login.errors.general');
            this.error = `${errorMessage} ${this.$t('login.errors.check')}`;
            this.$toast.error(this.error);
            this.isLoading = false;
            setTimeout(() => {
              this.$router.push({ path: '/auth/login' });
            }, 3000);
          }
        })
    }
  },
  mounted() {
    this.handleGoogleCallback();
  }
}
</script>

<template>
  <div class="google-callback">
    <div class="callback-content">
      <div v-if="error" class="error-message">
        {{ error }}
      </div>
      <div v-else-if="isLoading" class="loading-spinner">
        {{ $t('login.processing') }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.google-callback {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  color: #fff;
}

.callback-content {
  text-align: center;
  padding: 2rem;
}

.loading-spinner {
  font-size: 1.2rem;
}

.error-message {
  color: #ff4444;
  font-size: 1.1rem;
  margin-bottom: 1rem;
}
</style>